<template lang="pug">
#OtherZonedSchools(v-if="(schools || []).length")
    template(v-for="sb in schools")
        h4 For {{ stage }} enrolments, your address is in the {{ boundarySetTitle(sb.properties.queryYear).lowerCase() }} school zone for
        .container
            .school-summary-header
                .school-name {{ sb.properties.School_Name }}
            .key-detail Years: {{ sb.properties.Campus_Year_Levels }}
            .goto
                a(href="#" @click="click(sb, $event)") See more
</template>

<script>
import { EventBus } from './EventBus';
export default {
    name: 'OtherZonedSchools',
    props: ['schools'],
    data: () => ({
        // schoolsBoundaries: undefined,
        // otherZonedSchools: undefined,
    }),
    created() {
        window.app.OtherZonedSchools = this;
    },
    methods: {
        click(school, event) {
            event.preventDefault();
            EventBus.$emit('school-select', school, true);
            this.$nextTick(() =>
                document.getElementById('SchoolInfo').scrollIntoView()
            );
            window.track('App', 'see-more', 'other-zoned-schools');
        },
        boundarySetTitle(year) {
            return window.app.BoundarySelector.getBoundarySetTitle(year);
        },
    },
    computed: {
        stage() {
            return window.app.BoundarySelector.stage;
        },
    },
};
</script>

<style scoped>
.container {
    background: #e8effc;
    padding: 1em;
    border-radius: 3px;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    border: 1px solid grey;
    margin-bottom: 10px;
    font-size: 14px;
}

.school-summary-header {
    font-size: 14px;
    display: flex;
}

.school-name {
    font-weight: bold;
    flex: auto;
}

.goto {
    margin-top: 1em;
}
</style>
